import React from 'react'
import { withRouteData } from 'react-static'
import { Carousel } from 'react-bootstrap'

const Social = () => (
  <div id="social" className="section translucent-bg bg-image-5 pb-clear">
    <div
      className="container-fluid"
      data-animation-effect="fadeIn"
      style={{ marginTop: '4.5%' }}
        >
      <h1 className="title text-center" >
            Social
      </h1>
      <p className="lead text-center">
        <font color="#9AC032" />
      </p>
      <center>
        <h3>
          <font color="#9AC032">
            <strong>Charities <font color="white">We Support </font> </strong>
          </font>
        </h3>
      </center>
      <p />
      <div className="col-md-4 col-lg-4">
        <div className="media testimonial">
          <div className=" thumbnail">
            <img src="images/akshayapatra2.jpg" />
            <div className="video-container">
              <iframe
                title="akshayapatra"
                width={500}
                height={315}
                src="https://www.youtube.com/embed/ygUmOA1VaOM"
                frameBorder={0}
                allowFullScreen
                  />
            </div>
          </div>
        </div>
      </div>
      <div className=" col-md-8 col-lg-8 vcenter">
        <center>
          <a
            href="https://www.akshayapatra.org/"
            style={{
                  textDecoration: 'none',
                }}
            target="_blank"
              >
            <h3>
              <font color="#9AC032">
                <strong>Akshaya Patra</strong>
              </font>
            </h3>
          </a>
        </center>
            The Foundation is a not-for-profit organisation headquartered in
            Bengaluru, India. Our organisation strives to fight issues like
            hunger and malnutrition in India, by implementing the Mid-Day Meal
            Scheme in the government schools and government-aided schools.
            Akshaya Patra aims not only to fight hunger but also to bring
            children to school.Since 2000, the organisation has worked towards
            reaching more children with wholesome food on every single school
            day.<br />
                    In partnership with the Government of India; various State
            Governments, the inestimable support from many businesses,
            philanthropic donors and well-wishers; we have grown from our humble
            beginnings in the year 2000, serving just 1,500 children across 5
            schools. Today Akshaya Patra is the world’s largest (not-for-profit
            run) mid-day meal programme serving wholesome food to over<font color="#9AC032">
              <strong> 1.6 million</strong>
                                                                      </font>{' '}
            children from 13,529 schools across 11 states in India.<br />
        <br />
        <br />
      </div>
      <div className="row">
        <div className=" col-md-8 col-lg-8">
          <h3>
            <font color="#9AC032">
              <strong>
                <center>Balya</center>
              </strong>
            </font>
          </h3>
              Annapoorna Charitable trust, established in the year 2004, started
              working on its major important goal of establishing a home for the
              deprived children of the society. To fulfil this,{' '}
          <font color="#9AC032">
            <strong>“Balya”</strong>
          </font>{' '}
              a free home for children was established in the year 2005. Balya
              started functioning with the first two children Phalguni and
              Vaishaki in March 2005. This has blossomed into a home giving
              shelter, hygienic food, clothing, education and other
              opportunities for learning activities like music, dance etc to
              about 55 deprived children by year 2011.<br />
          <br />A girl named Chandramma who has many medals in track and
              field events in the Taluk level sports organized in the city.
              Chandramma grew up at Balya Girls Home and has keen interest in
              sports. With her dedication and with the support of good training
              she achieved many feats in sports. Her story was also reenacted
              since her childhood along with her brother and a video also was
              published on the social media titled “From begging to bagging
              medals”.
          <br /><br /><br />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">

          <Carousel style={{ height: '300px', width: '100%' }} controls interval={2000}>
            <Carousel.Item >
              <div className="item active">
                <center>
                  <img src="images/balya/pic1.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic2.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic3.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic4.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic5.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic6.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic7.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic8.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic9.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic10.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/balya/pic11.jpg" />
                </center>
              </div>
            </Carousel.Item>
          </Carousel>
          {/* <div className="media testimonial">
            <div className=" thumbnail">
              <img src="images/balyalogo.jpg" />


            </div>
          </div> */}
        </div>
      </div>
      <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">

<Carousel style={{ height: '300px', width: '100%' }} controls interval={2000}>
  <Carousel.Item >
    <div className="item active">
      <center>
        <img src="images/abhyudaya/Abhyudaya1.jpg" />
      </center>
    </div>
  </Carousel.Item>
  <Carousel.Item >
    <div className="item">
      <center>
        <img src="images/abhyudaya/Abhyudaya2.jpg" />
      </center>
    </div>
  </Carousel.Item>
  <Carousel.Item >
    <div className="item">
      <center>
        <img src="images/abhyudaya/Abhyudaya3.jpg" />
      </center>
    </div>
  </Carousel.Item>
  <Carousel.Item >
    <div className="item">
      <center>
        <img src="images/abhyudaya/Abhyudaya4.jpg" />
      </center>
    </div>
  </Carousel.Item>
</Carousel>
{/* <div className="media testimonial">
  <div className=" thumbnail">
    <img src="images/balyalogo.jpg" />


  </div>
</div> */}
</div>
      <div className=" col-md-8 col-lg-8 vcenter">
        <center>
          <a
            href="https://www.akshayapatra.org/"
            style={{
                  textDecoration: 'none',
                }}
            target="_blank"
              >
            <h3>
              <font color="#9AC032">
                <strong>Abhyudaya</strong>
              </font>
            </h3>
          </a>
        </center>
        Abhyudaya, came into being in 2004 as a project under Keshava Kripa Samvardhana Samiti (KKSS) as a Non-Profit Organization (NGO). Starting out as a free tuition center with 12 students, currently Abhyudaya reaches out to more than 3,600 students, spread across remote villages and slum clusters of Bengaluru through life skills, value based education and healthcare related activities. Socially deprived children, their families and the neighbourhood become the focus group of Abhyudaya activities as education must be imparted holistically. We believe, it is our solemn duty to educate children for the benefit of the society and country at large.
                                                                
        <br />
        <br />
        <br />
        
      </div>
      <div className="row">
        <div className=" col-md-8 col-lg-8">
          <h3>
            <font color="#9AC032">
              <strong>
                <center>OSAAT</center>
              </strong>
            </font>
          </h3>
          OSAAT is a registered non-profit organization,  focused on rebuilding infrastructure of needy rural schools in India, in dire need of a safe and strong infrastructure. OSAAT builds classrooms, toilets, kitchen and drinking water facility, at selected schools. OSAAT partners with other NGOs to achieve optimal results and long lasting positive impact on the schools.
OSAAT Operates as a 100% volunteer-run organization, 
Having successfully rebuilt schools in Karnataka, Maharashtra, Andhra Pradesh, Tamil Nadu and Uttar Pradesh, OSAAT continues to explore ways to help needy rural schools in other parts of India as well.
          <br /><br /><br />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">

          <Carousel style={{ height: '300px', width: '100%' }} controls interval={2000}>
            <Carousel.Item >
              <div className="item active">
                <center>
                  <img src="images/OSAAT/OSAAT1.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/OSAAT/OSAAT2.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/OSAAT/OSAAT3.jpg" />
                </center>
              </div>
            </Carousel.Item>
            <Carousel.Item >
              <div className="item">
                <center>
                  <img src="images/OSAAT/OSAAT4.jpg" />
                </center>
              </div>
            </Carousel.Item>
          </Carousel>
          {/* <div className="media testimonial">
            <div className=" thumbnail">
              <img src="images/balyalogo.jpg" />


            </div>
          </div> */}
        </div>
      </div>
    </div>
  </div>
)

export default Social



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/social.js